import "../../css/Common/SiteLoader.css";
export default function SiteLoader() {
    return (
        <div className="site-loader-overlay">
            <span className="theme-loader"></span>
        </div>
    );
}